import { FC } from 'react';
import { Chip, ChipProps, makeStyles } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  multiSelectChip: {
    borderRadius: '4px',
    backgroundColor: theme.palette.bkg.primary,
    '&:hover': {
      backgroundColor: theme.palette.bkg.primary,
    },
    fontWeight: 'normal',
    marginRight: 9,
    '&.MuiChip-deletable': {
      gap: theme.spacing(1),
    },
  },
  chipLabel: {
    wordBreak: 'break-all',
    paddingBlock: theme.spacing(0.5),
  },
}));

export const WbChip: FC<ChipProps> = ({ className, ...props }) => {
  const classes = useStyles();
  return (
    <Chip
      size="small"
      className={clsx(classes.multiSelectChip, className)}
      classes={{
        label: classes.chipLabel,
      }}
      deleteIcon={<ClearIcon onMouseDown={event => event.stopPropagation()} />}
      {...props}
    />
  );
};
